__turbopack_context__.v({
  "footer": "vo3Yga_footer",
  "sorting": "vo3Yga_sorting",
});
